import { render, staticRenderFns } from "./MaterialIcon.vue?vue&type=template&id=310eb946"
import script from "./MaterialIcon.vue?vue&type=script&lang=js"
export * from "./MaterialIcon.vue?vue&type=script&lang=js"
import style0 from "./MaterialIcon.vue?vue&type=style&index=0&id=310eb946&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports